<template>
	<div>
		<el-table :data="expandedTableData" v-loading="loading" element-loading-text="loading..." style="width: 100%" :span-method="objectSpanMethod" border>
			<el-table-column prop="customerName" :label="$t('messageSending.customerName')" min-width="120">
				<template slot-scope="scope">
					{{ scope.row.original_phone_group.name }}
				</template>
			</el-table-column>

			<el-table-column prop="phone_number" :label="$t('messageSending.customerPhone')" width="140">
				<template slot-scope="scope">
					<span class="phone-text">{{ scope.row.phone_number }}</span>
				</template>
			</el-table-column>

			<el-table-column prop="customer_id" :label="$t('messageSending.associatedRestaurantId')" min-width="150">
				<template slot-scope="scope">
					<el-tag size="mini" class="id-tag">
						{{ scope.row.customer_id }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="restaurantName" :label="$t('messageSending.restaurantName')" min-width="160">
				<template slot-scope="scope">
					<el-tag size="mini" type="success" class="name-tag">
						{{ scope.row.restaurant_name }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column :label="$t('messageSending.operate')" width="300" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" @click="goToHistory(scope.row)"> {{ $t("messageSending.historyRecord") }} </el-button>
					<el-button size="mini" type="primary" @click="handleSendMessageDialogForm(scope.row)" :disabled="scope.row.is_blacklisted">
						{{ $t("messageSending.sendMessage") }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 发送短信对话框 -->
		<el-dialog
			:title="$t('messageSending.sendMessage')"
			:visible.sync="showMessageModal"
			width="680px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<div class="message-form" v-loading="dialogLoading" element-loading-text="loading...">
				<div class="customer-info">
					<p>
						<strong>{{ $t("messageSending.customerName") }}：</strong>{{ selectedCustomerRow ? selectedCustomerRow.customer_name : "" }}
					</p>
					<p>
						<strong>{{ $t("messageSending.customerPhone") }}：</strong>{{ selectedCustomerRow ? selectedCustomerRow.phone_number : "" }}
					</p>
					<p>
						<strong>{{ $t("messageSending.sendDocument") }}</strong>
					</p>
				</div>

				<el-form ref="messageForm" label-position="left" v-if="selectedCustomerRow">
					<el-form-item
						v-for="customer in selectedCustomerRow.all_customers"
						:key="customer.customer_id"
						:label="$t('messageSending.restaurantId') + '：' + customer.customer_id"
						:prop="'content.' + customer.customer_id"
					>
						<el-checkbox-group v-model="messageForm.content[customer.customer_id]">
							<el-checkbox v-for="feature in customer.features" :key="feature.feature_key" :label="feature.feature_key">
								{{ feature.feature_name }}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="handleCloseMessageModal">{{ $t("messageSending.cancel") }}</el-button>
				<el-button
					type="primary"
					@click="handleConfirmSendMessage"
					:loading="sending"
					:disabled="!Object.values(this.messageForm.content).some((features) => features && features.length > 0)"
				>
					{{ $t("messageSending.confirm") }}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getMessageSendList, postSendMessage } from "../../services/api-v2/api-v2";
export default {
	name: "MessageSending",
	data() {
		return {
			messageSendData: [], // API直接返回的数据
			expandedTableData: [], // 展开后的表格数据，每个customer_id一行
			spanArr: [], // 用于存储每行合并的信息
			loading: false,
			showMessageModal: false,
			selectedCustomerRow: null, // 选中的单个客户行数据
			sending: false,
			dialogLoading: false,
			messageForm: {
				content: {},
			},
		};
	},
	mounted() {
		this.initMessageSendData();
	},
	created() {
		// 短信发送初始化数据
		this.initMessageSendData();
	},
	methods: {
		// 获取消息发送数据
		async initMessageSendData() {
			this.loading = true;
			try {
				const { data } = await getMessageSendList(this.customerId);
				this.messageSendData = data;
				// 将数据展开为每个customer_id一行
				this.expandDataByCustomerId();
				// 计算合并行数组
				this.getSpanArr();
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 将数据按customer_id展开，每个customer_id占一行
		expandDataByCustomerId() {
			this.expandedTableData = [];
			this.messageSendData.forEach((phoneGroup) => {
				phoneGroup.customers.forEach((customer) => {
					this.expandedTableData.push({
						phone_number: phoneGroup.phone_number,
						is_blacklisted: phoneGroup.is_blacklisted,
						customer_id: customer.customer_id,
						restaurant_name: customer.name,
						phone_number_comment: customer.phone_number_comment,
						phone_number_position: customer.phone_number_position,
						phone_number_languages: customer.phone_number_languages,
						features: customer.features,
						original_phone_group: phoneGroup, // 保留原始电话组数据的引用，用于发送消息时使用
					});
				});
			});
		},

		// 计算合并行数组（按电话号码合并）
		getSpanArr() {
			this.spanArr = [];
			let pos = 0;

			for (let i = 0; i < this.expandedTableData.length; i++) {
				if (i === 0) {
					this.spanArr.push(1);
					pos = 0;
				} else {
					// 如果当前行的电话号码与前一行相同，则合并
					if (this.expandedTableData[i].phone_number === this.expandedTableData[i - 1].phone_number) {
						this.spanArr[pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						pos = i;
					}
				}
			}
		},

		// 表格合并方法（只合并电话号码列和操作列）
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			// 对电话号码列（第2列）、客户名称列（第1列）和操作列（第5列）进行合并
			if (columnIndex === 0 || columnIndex === 1 || columnIndex === 4) {
				const _row = this.spanArr[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col,
				};
			}
		},

		// 跳转到历史记录页面
		goToHistory(row) {
			this.$router.push({
				path: `/setting/message-sending/${encodeURIComponent(row.phone_number)}`,
			});
		},

		// 点击发送短信按钮
		async handleSendMessageDialogForm(row) {
			// 查找该电话号码在原始数据中的完整客户信息
			const phoneGroup = this.messageSendData.find((item) => item.phone_number === row.phone_number);

			if (!phoneGroup) {
				return;
			}

			// 保存当前选中的行信息
			this.selectedCustomerRow = {
				phone_number: row.phone_number,
				customer_id: row.customer_id,
				restaurant_name: row.restaurant_name,
				customer_name: row.original_phone_group.name,
				features: row.features,
				is_blacklisted: row.is_blacklisted,
				// 附加该电话号码下的所有客户信息，并过滤每个 customer 的 features
				all_customers: phoneGroup.customers.map((customer) => ({
					...customer,
					features: (customer.features || []).filter((f) => !f.disabled),
				})),
			};

			this.showMessageModal = true;

			this.setDefaultSelectedItems();

			// 重置表单验证
			this.$nextTick(() => {
				if (this.$refs.messageForm) {
					this.$refs.messageForm.clearValidate();
				}
			});
		},

		// 设置默认全选
		setDefaultSelectedItems() {
			const content = {};
			if (this.selectedCustomerRow && this.selectedCustomerRow.all_customers) {
				this.selectedCustomerRow.all_customers.forEach((customer) => {
					content[customer.customer_id] = customer.features.map((f) => f.feature_key);
				});
			}
			this.messageForm.content = content;
		},

		// 确认发送短信
		async handleConfirmSendMessage() {
			try {
				await this.$refs.messageForm.validate();
			} catch (error) {
				return;
			}

			this.sending = true;

			try {
				const filteredCustomers = Object.keys(this.messageForm.content).reduce((acc, customerId) => {
					const features = this.messageForm.content[customerId];
					if (Array.isArray(features) && features.length > 0) {
						acc[customerId] = features;
					}
					return acc;
				}, {});

				const sendData = {
					phone_number: this.selectedCustomerRow.phone_number.toString(),
					customers: filteredCustomers,
				};

				await postSendMessage(sendData);

				this.$message.success(this.$t("messageSending.sendSuccess"));
				this.handleCloseMessageModal();
				this.initMessageSendData();
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.sending = false;
			}
		},

		// 关闭发送短信对话框
		handleCloseMessageModal() {
			this.showMessageModal = false;
			this.selectedCustomerRow = null;
			this.messageForm.content = {};
			this.sending = false;

			// 清除表单验证
			if (this.$refs.messageForm) {
				this.$refs.messageForm.clearValidate();
			}
		},
	},
};
</script>

<style scoped>
.customer-names,
.restaurant-ids,
.restaurant-names {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
}

.name-tag,
.id-tag {
	margin: 2px 0;
}

.phone-text {
	color: #409eff;
	font-weight: 500;
}

.dialog-footer {
	text-align: right;
}
.el-form {
	max-height: 300px;
	overflow-y: auto;
}
.el-form::-webkit-scrollbar {
	width: 6px;
}

.el-form::-webkit-scrollbar-track {
	background: #f1f1f1;
}

.el-form::-webkit-scrollbar-thumb {
	background: #9f9b9b;
	border-radius: 3px;
}

.el-form::-webkit-scrollbar-thumb:hover {
	background: #555;
}
</style>
